import React, { useEffect, useState } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

type ComponentProps = {
  onClick: (isHidden: boolean) => void
  collapseListItem: string[]
  allCollapseItemNum: number
}

export const RoomNameCollapseToggle: React.FC<ComponentProps> = props => {
  const { t } = useTranslation()
  const [isHidden, setIsHidden] = useState<boolean>(false)

  const onClickToggle = () => {
    setIsHidden(!isHidden)
    props.onClick(!isHidden)
  }

  useEffect(() => {
    const isAllOpened = props.collapseListItem.length === 0
    const isAllClosed = !isAllOpened && props.collapseListItem.length === props.allCollapseItemNum
    if (isAllOpened) {
      setIsHidden(true)
    } else if (isAllClosed) {
      setIsHidden(false)
    }
  }, [props.allCollapseItemNum, props.collapseListItem])

  return (
    <div css={showRoomNameWrapperStyle} onClick={onClickToggle}>
      <span>{isHidden ? '▲' : '▼'}</span>
      <div>{isHidden ? t('Room hidden') : t('Room display')}</div>
    </div>
  )
}

const showRoomNameWrapperStyle = css({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',

  color: '#676767',
  fontWeight: 'bold',
  '>span': { fontSize: 10 },
  '>div': {
    fontSize: 12,
    textDecoration: 'underline',
    paddingLeft: 4,
  },
})
